document.addEventListener('DOMContentLoaded', function () {
  // Calibrated once against the specific map image referenced by this section's
  // "expanded_map_image" setting (currently Speyside_c424acd3-...png, 940x725) - percentages are
  // relative to the image container, not metaobject fields, since this mapping isn't meant to be
  // recalculated at build time. Re-calibrate this whole array if the map image is ever replaced.
  var PIN_POSITIONS = [
    { name: 'Glenfiddich', left: 61.88, top: 56.0 },
    { name: 'The Macallan', left: 55.75, top: 50.34 },
    { name: 'The Glenlivet', left: 45.69, top: 76.79 },
    { name: 'Aberlour', left: 54.07, top: 53.55 },
    { name: 'The Glenrothes', left: 55.07, top: 42.67 },
    { name: 'Cardhu', left: 44.75, top: 53.19 },
    { name: 'The Balvenie', left: 61.9, top: 55.23 },
    { name: 'GlenAllachie', left: 54.13, top: 55.96 },
    { name: 'Cragganmore', left: 41.86, top: 64.14 },
    { name: 'Glenfarclas', left: 47.41, top: 61.28 },
    { name: 'Strathisla', left: 75.23, top: 38.63 },
    { name: 'Speyburn', left: 55.06, top: 40.81 },
    { name: 'Glen Grant', left: 55.5, top: 42.0 },
    { name: 'Tamdhu', left: 44.66, top: 55.14 },
    { name: 'Benromach', left: 23.94, top: 26.78 },
    { name: 'Tomintoul', left: 40.01, top: 82.6 },
    { name: 'Longmorn', left: 49.92, top: 27.48 },
    { name: 'Glen Moray', left: 45.39, top: 20.83 },
    { name: 'Allt-a-Bhainne', left: 55.85, top: 67.2 },
    { name: 'Auchroisk', left: 62.84, top: 38.67 },
    { name: 'Aultmore', left: 71.53, top: 34.84 },
    { name: 'Ballindalloch', left: 43.37, top: 65.28 },
    { name: 'Balmenach', left: 30.77, top: 80.31 },
    { name: 'BenRiach', left: 49.13, top: 26.94 },
    { name: 'Benrinnes', left: 53.49, top: 58.41 },
    { name: 'Braeval', left: 51.85, top: 90.12 },
    { name: 'Cabrach', left: 69.41, top: 72.28 },
    { name: 'Cairn', left: 23.24, top: 83.29 },
    { name: 'Craigellachie', left: 57.49, top: 49.67 },
    { name: 'Dailuaine', left: 50.69, top: 56.47 },
    { name: 'Dalmunach', left: 48.57, top: 56.06 },
    { name: 'Dufftown', left: 61.88, top: 59.41 },
    { name: 'Dunphail', left: 24.7, top: 43.46 },
    { name: 'Glenburgie', left: 31.85, top: 25.23 },
    { name: 'Glendullan', left: 62.54, top: 56.83 },
    { name: 'Glen Elgin', left: 50.26, top: 29.18 },
    { name: 'Glen Keith', left: 75.0, top: 38.65 },
    { name: 'Glenlossie', left: 47.07, top: 29.34 },
    { name: 'Glen Spey', left: 55.52, top: 42.82 },
    { name: 'Glentauchers', left: 67.89, top: 41.04 },
    { name: 'Inchgower', left: 74.6, top: 17.31 },
    { name: 'Kininvie', left: 61.95, top: 55.02 },
    { name: 'Knockando', left: 44.88, top: 55.71 },
    { name: 'Knockdhu', left: 90.27, top: 35.37 },
    { name: 'Linkwood', left: 49.58, top: 22.48 },
    { name: 'Mannochmore', left: 47.64, top: 28.95 },
    { name: 'Miltonduff', left: 43.2, top: 24.75 },
    { name: 'Mortlach', left: 62.31, top: 58.01 },
    { name: 'Roseisle', left: 35.02, top: 16.49 },
    { name: 'Strathmill', left: 74.66, top: 39.85 },
    { name: 'Tamnavulin', left: 48.03, top: 81.48 },
    { name: 'Tormore', left: 40.28, top: 66.72 },
  ];

  // Tunable - distance in rendered pixels within which pins get grouped into one cluster badge.
  // Re-check against the real image at real container size if pins look wrongly split/merged
  // (52 points cluster more densely around Dufftown/Rothes/Craigellachie than a sparser set
  // would).
  var CLUSTER_RADIUS_PX = 26;
  var ZOOM_SCALE = 2.2;

  function normalizeName(name) {
    return (name || '')
      .toLowerCase()
      .replace(/^the\s+/, '')
      .replace(/[^a-z0-9]/g, '');
  }

  document.querySelectorAll('[data-speyside-pin-map]').forEach(function (root) {
    var details = root.closest('details');
    // distillery-map-explorer.liquid's own accordion arrow (see section-distillery-map-
    // explorer.js) toggles this wrapper's "hidden" attribute - a closer, more specific ancestor
    // than the region showcase panel below, which may already be visible by the time this inner
    // wrapper first reveals.
    var mapWrap = root.closest('[data-speyside-map-wrap]');
    var showcasePanel = root.closest('.distillery-explorer__region-showcase-panel');
    var scope = details || root.closest('.islay-map-section') || showcasePanel || document;
    var initialized = false;

    function initMap() {
      if (initialized) return;
      initialized = true;

      var inner = root.querySelector('[data-speyside-pin-map-inner]');
      var image = inner ? inner.querySelector('.speyside-pin-map__image') : null;
      var resetBtn = root.querySelector('[data-speyside-pin-map-reset]');
      var lookupScript = scope.querySelector('[data-speyside-distillery-lookup]');

      // The detail view lives inside the region-info box (a sibling of the map, not an overlay
      // on top of it) - clicking a pin/cluster swaps that box's content rather than covering the
      // map with a floating panel, so the map itself is never obstructed.
      var regionInfoDefault = scope.querySelector('[data-speyside-region-info-default]');
      var pinDetail = scope.querySelector('[data-speyside-pin-detail]');
      var pinDetailBody = scope.querySelector('[data-speyside-pin-detail-body]');
      var pinDetailBack = scope.querySelector('[data-speyside-pin-detail-back]');

      if (!inner) return;

      var lookupByName = {};
      if (lookupScript) {
        try {
          JSON.parse(lookupScript.textContent).forEach(function (d) {
            lookupByName[normalizeName(d.name)] = d;
          });
        } catch (e) {
          console.warn('Speyside pin map: failed to parse distillery lookup JSON.', e);
        }
      }

      // Rich Islay-style panels (see snippets/speyside-pin-map.liquid) - only rendered server-side
      // ('filter' shop_mode only) for the handful of Speyside distilleries that actually have a
      // metaobject entry. Pins with no matching panel here keep today's plain Shop/"Coming soon"
      // list behaviour untouched (see buildDetailItem/render below).
      var distilleryPanels = scope.querySelectorAll('[data-speyside-distillery-detail]');
      var panelsByName = {};
      distilleryPanels.forEach(function (panel) {
        panelsByName[normalizeName(panel.dataset.distilleryName || '')] = panel;
      });

      // Remembers whether the currently-open distillery panel should return to the cluster list
      // it was opened from, or straight back to the default region facts - set by
      // showDistilleryDetail, read by each panel's own Back button.
      var distilleryDetailCameFrom = 'default';

      function hideAllDistilleryPanels() {
        distilleryPanels.forEach(function (panel) {
          panel.hidden = true;
        });
      }

      function showDistilleryDetail(name, cameFrom) {
        var panel = panelsByName[normalizeName(name)];
        if (!panel) return false;
        distilleryDetailCameFrom = cameFrom;
        if (regionInfoDefault) regionInfoDefault.hidden = true;
        // pinDetail is hidden, not cleared - its content (the cluster list) stays intact so
        // returning to it via Back doesn't need rebuilding.
        if (pinDetail) pinDetail.hidden = true;
        hideAllDistilleryPanels();
        panel.hidden = false;
        return true;
      }

      // "Shop" filters the current Speyside collection grid in-page rather than navigating to a
      // separate distillery collection - same fuzzy checkbox-matching approach as Islay's
      // activateDistillery (assets/section-islay-distillery-map.js), reused independently here
      // since this file has no dependency on that one. hasFilterMatch is read-only (used to
      // decide Shop vs Coming Soon at render time); activateDistillery actually flips the
      // checkbox and triggers facets.js's AJAX refetch.
      function hasFilterMatch(name) {
        var needle = name.trim().toLowerCase();
        var found = false;
        document.querySelectorAll('[data-distillery-controls] .whisky-filter__item').forEach(function (item) {
          var searchText = (item.dataset.filterSearchText || '').toLowerCase();
          var checkbox = item.querySelector('input[type="checkbox"]');
          if (!checkbox || checkbox.disabled) return;
          if (searchText === needle || searchText.indexOf(needle) !== -1 || needle.indexOf(searchText) !== -1) {
            found = true;
          }
        });
        return found;
      }

      function activateDistillery(name) {
        var needle = name.trim().toLowerCase();

        document.querySelectorAll('[data-distillery-controls]').forEach(function (controls) {
          var items = controls.querySelectorAll('.whisky-filter__item');
          var targetCheckbox = null;

          items.forEach(function (item) {
            var searchText = (item.dataset.filterSearchText || '').toLowerCase();
            var checkbox = item.querySelector('input[type="checkbox"]');
            if (!checkbox) return;
            if (searchText === needle || searchText.indexOf(needle) !== -1 || needle.indexOf(searchText) !== -1) {
              if (!checkbox.disabled) targetCheckbox = checkbox;
            }
          });

          if (!targetCheckbox) return;

          items.forEach(function (item) {
            var checkbox = item.querySelector('input[type="checkbox"]');
            if (checkbox && checkbox !== targetCheckbox && checkbox.checked) {
              checkbox.checked = false;
            }
          });

          if (!targetCheckbox.checked) targetCheckbox.checked = true;
          targetCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
          targetCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        });

        var grid = document.getElementById('ProductGridContainer');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // 'filter' (default): Shop checks/activates the real distillery filter on THIS collection
      // page and scrolls to the grid - used on the Speyside collection page. 'link': Shop
      // navigates to the distillery's own linked_collection - used on the distillery-map-
      // explorer page, which has no product grid of its own to filter.
      var shopMode = root.dataset.shopMode === 'link' ? 'link' : 'filter';

      var pins = PIN_POSITIONS.map(function (p) {
        var match = lookupByName[normalizeName(p.name)];
        if (!match) {
          console.warn(
            'Speyside pin map: "' + p.name + '" has no matching distillery metaobject (region "Speyside") - ' +
            'pin will still render without a region label, though it may still be shoppable if the ' +
            'collection has real products tagged to it.'
          );
        }
        return {
          name: p.name,
          left: p.left,
          top: p.top,
          region: match ? match.region : null,
          url: match ? match.url : null,
          canShop: shopMode === 'link' ? !!(match && match.url) : hasFilterMatch(p.name),
        };
      });

      if (resetBtn) resetBtn.hidden = true;

      function buildDetailItem(pin) {
        var item = document.createElement('div');
        item.className = 'speyside-pin-detail__item';

        var textWrap = document.createElement('div');
        textWrap.className = 'speyside-pin-detail__text';

        var name = document.createElement('span');
        name.className = 'speyside-pin-detail__name';
        name.textContent = pin.name;
        textWrap.appendChild(name);

        if (pin.region) {
          var region = document.createElement('span');
          region.className = 'speyside-pin-detail__region';
          region.textContent = pin.region;
          textWrap.appendChild(region);
        }

        item.appendChild(textWrap);

        // panelsByName is only ever populated with whatever Liquid actually rendered a panel for
        // (both shop_modes now, see snippets/speyside-pin-map.liquid) - no need to also gate on
        // shopMode here.
        var hasRichPanel = !!panelsByName[normalizeName(pin.name)];

        if (hasRichPanel) {
          var exploreBtn = document.createElement('button');
          exploreBtn.type = 'button';
          exploreBtn.className = 'speyside-pin-detail__shop';
          exploreBtn.textContent = 'Explore ';
          var exploreArrow = document.createElement('span');
          exploreArrow.setAttribute('aria-hidden', 'true');
          exploreArrow.textContent = '→';
          exploreBtn.appendChild(exploreArrow);
          exploreBtn.addEventListener('click', function () {
            showDistilleryDetail(pin.name, 'cluster');
          });
          item.appendChild(exploreBtn);
        } else if (pin.canShop) {
          var shopBtn = document.createElement(shopMode === 'link' ? 'a' : 'button');
          if (shopMode === 'link') {
            shopBtn.href = pin.url;
          } else {
            shopBtn.type = 'button';
          }
          shopBtn.className = 'speyside-pin-detail__shop';
          shopBtn.textContent = 'Shop ';
          var arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          shopBtn.appendChild(arrow);
          if (shopMode !== 'link') {
            shopBtn.addEventListener('click', function () {
              activateDistillery(pin.name);
            });
          }
          item.appendChild(shopBtn);
        } else {
          var comingSoon = document.createElement('span');
          comingSoon.className = 'speyside-pin-detail__shop speyside-pin-detail__shop--disabled';
          comingSoon.textContent = 'Coming soon';
          item.appendChild(comingSoon);
        }

        return item;
      }

      function showDetail(heading, detailPins) {
        if (!pinDetail || !pinDetailBody || !regionInfoDefault) return;
        pinDetailBody.innerHTML = '';
        var headingEl = document.createElement('h3');
        headingEl.className = 'speyside-pin-detail__heading';
        headingEl.textContent = heading;
        pinDetailBody.appendChild(headingEl);
        detailPins.forEach(function (pin) {
          pinDetailBody.appendChild(buildDetailItem(pin));
        });
        regionInfoDefault.hidden = true;
        hideAllDistilleryPanels();
        pinDetail.hidden = false;
      }

      function showRegionInfoDefault() {
        if (!pinDetail || !regionInfoDefault) return;
        pinDetail.hidden = true;
        hideAllDistilleryPanels();
        regionInfoDefault.hidden = false;
      }

      // Single source of truth for inner's transform, so drag-panning (below) can compose with
      // whatever zoom state is currently active instead of fighting it or needing to re-parse
      // the transform string back out of inner.style.
      var xf = { tx: 0, ty: 0, scale: 1, originX: 0, originY: 0 };

      function applyTransform() {
        inner.style.transformOrigin = xf.originX + 'px ' + xf.originY + 'px';
        inner.style.transform = xf.scale === 1 && xf.tx === 0 && xf.ty === 0
          ? ''
          : 'translate(' + xf.tx + 'px, ' + xf.ty + 'px) scale(' + xf.scale + ')';
      }

      function resetZoom() {
        xf = { tx: 0, ty: 0, scale: 1, originX: 0, originY: 0 };
        applyTransform();
        root.classList.remove('is-zoomed');
        if (resetBtn) resetBtn.hidden = true;
      }

      function zoomToCluster(leftPct, topPct) {
        // Measured from root (.speyside-pin-map), NOT inner - inner is the element the zoom
        // transform is actually applied to, so its own getBoundingClientRect() would reflect
        // the CURRENT scaled size once already zoomed in, corrupting the math for every
        // subsequent cluster click made without resetting first. root is never itself
        // transformed, so it's a stable, transform-independent reference every time.
        var rect = root.getBoundingClientRect();
        var ox = (leftPct / 100) * rect.width;
        var oy = (topPct / 100) * rect.height;
        var dx = rect.width / 2 - ox;
        var dy = rect.height / 2 - oy;
        xf = { tx: dx, ty: dy, scale: ZOOM_SCALE, originX: ox, originY: oy };
        applyTransform();
        root.classList.add('is-zoomed');
        if (resetBtn) resetBtn.hidden = false;
      }

      // Click-and-drag panning, Google-Maps style - only meaningful once zoomed in (at scale 1
      // the whole map already fits with nothing extra to reveal). Panning adjusts tx/ty on top
      // of whatever zoom is currently active; transform-origin is left untouched by dragging, so
      // panning and the initial cluster zoom compose correctly without fighting each other.
      var isDragging = false;
      var dragMoved = false;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartTx = 0;
      var dragStartTy = 0;
      var DRAG_CLICK_THRESHOLD_PX = 4;

      function eventPoint(event) {
        var t = event.touches && event.touches[0];
        return t ? { x: t.clientX, y: t.clientY } : { x: event.clientX, y: event.clientY };
      }

      // Corrects tx/ty (after the fact, on the actually-rendered boxes) so inner's edges never
      // recede past root's edges and leave visible blank space - simpler and more robust than
      // pre-computing bounds algebraically against transform-origin.
      function clampPan() {
        var rootRect = root.getBoundingClientRect();
        var innerRect = inner.getBoundingClientRect();
        var correctionX = 0;
        var correctionY = 0;
        if (innerRect.width <= rootRect.width) {
          correctionX = rootRect.left + (rootRect.width - innerRect.width) / 2 - innerRect.left;
        } else {
          if (innerRect.left > rootRect.left) correctionX = rootRect.left - innerRect.left;
          else if (innerRect.right < rootRect.right) correctionX = rootRect.right - innerRect.right;
        }
        if (innerRect.height <= rootRect.height) {
          correctionY = rootRect.top + (rootRect.height - innerRect.height) / 2 - innerRect.top;
        } else {
          if (innerRect.top > rootRect.top) correctionY = rootRect.top - innerRect.top;
          else if (innerRect.bottom < rootRect.bottom) correctionY = rootRect.bottom - innerRect.bottom;
        }
        if (correctionX || correctionY) {
          xf.tx += correctionX;
          xf.ty += correctionY;
          applyTransform();
        }
      }

      function onDragStart(event) {
        if (xf.scale <= 1) return;
        isDragging = true;
        dragMoved = false;
        var p = eventPoint(event);
        dragStartX = p.x;
        dragStartY = p.y;
        dragStartTx = xf.tx;
        dragStartTy = xf.ty;
        root.classList.add('is-dragging');
        event.preventDefault();
      }

      function onDragMove(event) {
        if (!isDragging) return;
        var p = eventPoint(event);
        var deltaX = p.x - dragStartX;
        var deltaY = p.y - dragStartY;
        if (Math.abs(deltaX) > DRAG_CLICK_THRESHOLD_PX || Math.abs(deltaY) > DRAG_CLICK_THRESHOLD_PX) {
          dragMoved = true;
        }
        xf.tx = dragStartTx + deltaX;
        xf.ty = dragStartTy + deltaY;
        applyTransform();
        clampPan();
        event.preventDefault();
      }

      function onDragEnd() {
        if (!isDragging) return;
        isDragging = false;
        root.classList.remove('is-dragging');
      }

      root.addEventListener('mousedown', onDragStart);
      document.addEventListener('mousemove', onDragMove);
      document.addEventListener('mouseup', onDragEnd);
      root.addEventListener('touchstart', onDragStart, { passive: false });
      document.addEventListener('touchmove', onDragMove, { passive: false });
      document.addEventListener('touchend', onDragEnd);

      // Two jobs for this one capture-phase listener:
      // 1. Suppress the click a drag gesture would otherwise fire on whatever pin/cluster the
      //    pointer happened to end up over.
      // 2. A genuine (non-drag) click on empty map background - i.e. not on a pin/cluster -
      //    restores the right-hand panel to its first-load state (region facts) and resets the
      //    zoom, same as the explicit "Back" button.
      inner.addEventListener(
        'click',
        function (event) {
          if (dragMoved) {
            event.stopImmediatePropagation();
            event.preventDefault();
            return;
          }
          var hitPinOrCluster = event.target.closest('.speyside-pin, .speyside-pin--cluster');
          if (!hitPinOrCluster) {
            showRegionInfoDefault();
            markActivePin(null);
            resetZoom();
          }
        },
        true
      );

      function markActivePin(activeEl) {
        inner.querySelectorAll('.speyside-pin.is-active, .speyside-pin--cluster.is-active').forEach(function (el) {
          el.classList.remove('is-active');
        });
        if (activeEl) activeEl.classList.add('is-active');
      }

      // Groups pins within CLUSTER_RADIUS_PX of each other (simple greedy nearest-cluster
      // grouping - no external clustering library, per explicit direction not to add a build
      // step to this project just for supercluster). Re-run on every render() call, keyed off
      // the container's CURRENT rendered pixel size, so cluster grouping stays correct across
      // viewport/resize changes rather than being computed once against a stale size.
      function buildClusters() {
        // root, not inner, for the same reason as zoomToCluster above - only ever called while
        // unzoomed today (render() isn't invoked mid-zoom), but measuring the untransformed
        // element is the robust choice regardless of future call sites.
        var rect = root.getBoundingClientRect();
        var width = rect.width;
        var height = rect.height;
        if (!width || !height) return [];

        var points = pins.map(function (p) {
          return { pin: p, x: (p.left / 100) * width, y: (p.top / 100) * height };
        });

        var clusters = [];
        points.forEach(function (point) {
          var target = null;
          for (var i = 0; i < clusters.length; i++) {
            var c = clusters[i];
            var dx = c.x - point.x;
            var dy = c.y - point.y;
            if (Math.sqrt(dx * dx + dy * dy) <= CLUSTER_RADIUS_PX) {
              target = c;
              break;
            }
          }
          if (target) {
            target.points.push(point);
            target.x = target.points.reduce(function (sum, pt) { return sum + pt.x; }, 0) / target.points.length;
            target.y = target.points.reduce(function (sum, pt) { return sum + pt.y; }, 0) / target.points.length;
          } else {
            clusters.push({ x: point.x, y: point.y, points: [point] });
          }
        });

        return clusters.map(function (c) {
          return {
            leftPct: (c.x / width) * 100,
            topPct: (c.y / height) * 100,
            pins: c.points.map(function (pt) { return pt.pin; }),
          };
        });
      }

      // Caps the region-info box's height to match the map's rendered height (it scrolls
      // internally past that via CSS overflow-y - see .speyside-map-columns .islay-region-info)
      // rather than growing taller than the map, e.g. when a cluster's detail list is long.
      var infoBox = root.parentElement ? root.parentElement.querySelector('.islay-region-info') : null;

      function syncInfoBoxHeight() {
        // Both placements now show the card in full instead of capping/scrolling it to the map's
        // height (see the plain overflow-y: visible rule on .speyside-map-columns .islay-region-
        // info in section-speyside-pin-map.css) - kept as a no-op function, rather than removing
        // it and its call sites, in case a capped/scrolling treatment is ever wanted again.
        return;
      }

      // The Flavour Profile accordion (native <details>, no custom JS needed for the accordion
      // itself) can reveal content below whatever's currently visible in infoBox's own scroll
      // area (it has a capped max-height via syncInfoBoxHeight above) - auto-scroll to the newly
      // revealed body on open, rather than leaving the user to notice and scroll manually.
      var flavourAccordion = infoBox ? infoBox.querySelector('.islay-region-info__flavour-accordion') : null;
      var flavourBody = infoBox ? infoBox.querySelector('.islay-region-info__flavour-body') : null;
      if (flavourAccordion && flavourBody) {
        flavourAccordion.addEventListener('toggle', function () {
          if (flavourAccordion.open) {
            flavourBody.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }

      function render() {
        inner.querySelectorAll('.speyside-pin, .speyside-pin--cluster').forEach(function (el) {
          el.remove();
        });

        buildClusters().forEach(function (cluster) {
          if (cluster.pins.length === 1) {
            var pin = cluster.pins[0];
            var el = document.createElement('button');
            el.type = 'button';
            el.className = 'speyside-pin';
            el.style.left = cluster.leftPct + '%';
            el.style.top = cluster.topPct + '%';
            el.setAttribute('aria-label', pin.name);
            el.title = pin.name;
            el.addEventListener('click', function () {
              markActivePin(el);
              // A single (non-clustered) pin with a rich panel goes straight to it - same
              // one-step behaviour as Islay's pin/legend clicks - skipping the intermediate
              // single-item list. Pins with no panel keep today's list-with-Shop-button exactly
              // as before.
              if (!showDistilleryDetail(pin.name, 'default')) {
                showDetail(pin.name, [pin]);
              }
            });
            inner.appendChild(el);
          } else {
            var badge = document.createElement('button');
            badge.type = 'button';
            badge.className = 'speyside-pin--cluster';
            var size = Math.min(46, 24 + cluster.pins.length * 2.5);
            badge.style.width = size + 'px';
            badge.style.height = size + 'px';
            badge.style.left = cluster.leftPct + '%';
            badge.style.top = cluster.topPct + '%';
            badge.textContent = cluster.pins.length;
            badge.setAttribute('aria-label', cluster.pins.length + ' distilleries');
            (function (leftPct, topPct, clusterPins) {
              badge.addEventListener('click', function () {
                markActivePin(badge);
                zoomToCluster(leftPct, topPct);
                showDetail(clusterPins.length + ' Distilleries', clusterPins);
              });
            })(cluster.leftPct, cluster.topPct, cluster.pins);
            inner.appendChild(badge);
          }
        });
      }

      if (pinDetailBack) {
        pinDetailBack.addEventListener('click', function () {
          showRegionInfoDefault();
          markActivePin(null);
          resetZoom();
        });
      }
      if (resetBtn) resetBtn.addEventListener('click', resetZoom);
      // Clicking empty map background also closes the detail view (see the capture-phase click
      // listener on inner above) - equivalent to clicking "Back" without needing to find it.

      // Each rich distillery panel's own Back button returns to whichever view it was opened
      // from - the cluster list it came from (still intact, just hidden - see
      // showDistilleryDetail) if opened via an "Explore" button, or straight to the default
      // region facts if opened directly from a non-clustered pin.
      distilleryPanels.forEach(function (panel) {
        var backBtn = panel.querySelector('[data-speyside-distillery-detail-back]');
        if (!backBtn) return;
        backBtn.addEventListener('click', function () {
          if (distilleryDetailCameFrom === 'cluster' && pinDetail) {
            // Returning to the cluster list, not the full map - the map should stay zoomed into
            // that cluster with it still highlighted/pulsing, exactly as the user left it, not
            // reset to the unzoomed full-map view (which was the bug: resetZoom()/markActivePin
            // were previously called unconditionally here, even on this path).
            regionInfoDefault.hidden = true;
            panel.hidden = true;
            pinDetail.hidden = false;
          } else {
            markActivePin(null);
            resetZoom();
            showRegionInfoDefault();
          }
        });
      });

      // "Show N bottles" link at the bottom of each rich panel - same in-page filter-and-scroll
      // behaviour as the Shop button above, reusing the same activateDistillery.
      distilleryPanels.forEach(function (panel) {
        var viewBottlesLink = panel.querySelector('[data-speyside-view-bottles]');
        if (!viewBottlesLink) return;
        viewBottlesLink.addEventListener('click', function (event) {
          if (hasFilterMatch(viewBottlesLink.dataset.distilleryName || '')) {
            event.preventDefault();
            activateDistillery(viewBottlesLink.dataset.distilleryName || '');
          }
        });
      });

      render();
      syncInfoBoxHeight();

      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          resetZoom();
          render();
          syncInfoBoxHeight();
        }, 200);
      });
    }

    if (details) {
      if (details.open) initMap();
      details.addEventListener('toggle', function () {
        if (details.open) initMap();
      });
    } else if (mapWrap) {
      if (!mapWrap.hidden) {
        initMap();
      } else {
        var wrapObserver = new MutationObserver(function () {
          if (!mapWrap.hidden) {
            initMap();
            wrapObserver.disconnect();
          }
        });
        wrapObserver.observe(mapWrap, { attributes: true, attributeFilter: ['hidden'] });
      }
    } else if (showcasePanel) {
      // distillery-map-explorer.liquid has no <details> wrapper - the Speyside panel is instead
      // shown/hidden via its "hidden" attribute (see section-distillery-map-explorer.js's
      // activateRegion). A MutationObserver is the only way to react to an arbitrary attribute
      // change like this (there's no native "unhidden" event), mirroring the same "defer
      // geometry-dependent init until visible" principle the <details> branch above uses.
      if (!showcasePanel.hidden) {
        initMap();
      } else {
        var panelObserver = new MutationObserver(function () {
          if (!showcasePanel.hidden) {
            initMap();
            panelObserver.disconnect();
          }
        });
        panelObserver.observe(showcasePanel, { attributes: true, attributeFilter: ['hidden'] });
      }
    } else {
      initMap();
    }
  });
});
